
import { getGSheetsJSON } from './services'
import {
     slugify ,
 } from './utils'
export default class Keywords {
    constructor(selector, options) {
        this.selector = selector,
        this.options = Object.assign({
            enableGridMobile: false,
            catImgPrefix: ''
        }, options)

        this.init();
    }
    init() {      
        this.getData().then(data =>this.renderHTML(data));
        
    }

    getData() {
      
        return getGSheetsJSON(`https://spreadsheets.google.com/feeds/list/${this.options.sheetKey}/0${this.options.sheetIndex}/public/values?alt=json`)
      
    }
    renderHTML(data) {      
        
     
        data.filter((elemento) => {  
         
            return elemento.gsx$keywords.$t !== ""
         }).forEach((item) => {  
           
            let itemHmtl = ` <h3 class="keyword-heading">Encuentra mas productos en: </h3> `

            try {
               item.gsx$keywords.$t.match(/(?:\[).+?(?:\])/g).forEach(function (elemento) {
               
                  const splitStrig = elemento.replace('[', '').replace(']', '').split(',');      
                //   console.log("funcion keyword" , splitStrig)  
                  itemHmtl += `<a class="item-keyword" href="/sodimac-pe/${splitStrig[1].charAt(0) ==='a' ?'content':'category'}/${splitStrig[1]}/${slugify(splitStrig[0])}/?cid=${splitStrig[2]}">${splitStrig[0]}</a>`                                   
               });
               
               const keywordsEl = document.querySelector('#section-' + slugify(item.gsx$name.$t) + ' .section-promo__keywords') 
               if (keywordsEl) {
                  keywordsEl.innerHTML = itemHmtl
               }
            } catch(err) {
               console.error(err)
            }
         })

    }
}

